import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';

import {
    Table,Col, Row, Card, CardBody,
    CardTitle, Button, Form, FormGroup, Label, Input,Modal
} from 'reactstrap';
import Parametri from '../../parametri';
import TendinaEditabile from '../TendinaEditabile.js';
import TrasformaDateAUmano from '../TrasformaDateAUmano.js';
import FormattaImportoVideo from '../FormattaImportoVideo.js';
import FormattaImportoDb from '../FormattaImportoDb.js';
import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';
import FinestraDialogo from '../FinestraDialogo.js';
import VisualizzaRicevuta from './VisualizzaRicevuta.js';

import Interrogativo from '../../immagini/interrogativo-azzurro.png';
import Cerchio_ok from '../../immagini/cerchio_ok.png';
import Cerchio_no from '../../immagini/cerchio_no.png';
import controllaDataAAAAMMGG from '../controllaDataAAAAMMGG.js';

import { haPersonalizzazione } from '../../funzioni.js';

const STATO_INDEFINITO = 0;
const STATO_RICERCA_DATI_INIZIALI = 1;
const STATO_INSERIMENTO_DATI = 2;
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_VISUALIZZA_RICEVUTA = 4;

function SchedaIncassiAbbAssUnificata(props) {
    var today = new Date();
    let sMese = String(today.getMonth()+1);
    if(sMese.length === 1) sMese = "0"+sMese;
    let sGiorno = String(today.getDate());
    if(sGiorno.length === 1) sGiorno = "0"+sGiorno;
    const dataOggi = today.getFullYear()+'-'+sMese+'-'+sGiorno

    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [disabilitaBottoni,setDisabilitaBottoni]= useState(false);
    const [flagAttivaModaleRichiediPermessoInserire, setFlagAttivaModaleRichiediPermessoInserire] = useState(0);
    const [permessoInserireRisorsa,setPermessoInserireRisorsa]=useState(0);
    const [permessoInserireVoceDiBilancio,setPermessoInserireVoceDiBilancio]=useState(0);    
    const [risultatoServerDatiRisorse,setRisultatoServerDatiRisorse]=useState('');
    const [risultatoServerDatiVocidiBilancio,setRisultatoServerDatiVocidiBilancio]=useState('');
    const [risultatoServerDatiDovutoQuoteIscritto,setRisultatoServerDatiDovutoQuoteIscritto]=useState([]);
    const [risultatoServerDatiIscritti,setRisultatoServerDatiIscritti]=useState('');
    const [elencoRiferimenti, setElencoRiferimenti] = useState([]);
    const [indiceRiferimentoSelezionato, setIndiceRiferimentoSelezionato] = useState(-1);
    const [insIscrittiEdi,setInsIscrittiEdi]=useState('');
    const [insRisorsaEdi,setInsRisorsaEdi]=useState('');
    const [insVociDiBilancioEdi,setInsVociDiBilancioEdi]=useState('');
    const [insVociDiBilancioAttEdi,setInsVociDiBilancioAttEdi]=useState('');
    const [flagAlertVisivoDestinatarioRicevuta, setFlagAlertVisivoDestinatarioRicevuta] = useState(false);
    const [sequenzaScaricaDatiIniziali, setSequenzaScaricaDatiIniziali] = useState(0);    
    const [importi, setImporti] = useState([]);
    const [dataPagamento,setDataPagamento]=useState(dataOggi);
    const [notePagamento,setNotePagamento]=useState('');
    const [flagAttivaModaleSpiegaAttivita, setFlagAttivaModaleSpiegaAttivita] = useState(0);
    const [jsonRicevuta, setJsonRicevuta] = useState("");

    const regexNumeroValido = /^-?\d+([,.]\d{1,2})?$/;

    useEffect(() => {
        setStatoPagina(STATO_RICERCA_DATI_INIZIALI);        
    },[]);

    useEffect(() => {
        const viste = new Set();
        const oggi = new Date();

        const iniziali = risultatoServerDatiDovutoQuoteIscritto.map(el => {
            const chiave = `${el.IDASSABB}_${el.TIPO_QUOTA}`; // nuova chiave univoca per abbonamento
            const importo = parseFloat(el.IMPORTO).toFixed(2).replace(".", ",");
            const dataRata = new Date(el.DATA_RATA);

            const isPrimaRata = !viste.has(chiave);
            if (isPrimaRata) {
                viste.add(chiave);
            }

            // Se NON è la prima rata ed è futura, azzera IMPORTO
            const importoFinale = (!isPrimaRata && dataRata >= oggi) ? "0,00" : importo;            

            return {
                IDASSABB: el.IDASSABB,
                DESCRIZIONE: el.DESCRIZIONE,
                TIPOQUOTA: el.TIPO_QUOTA,
                DATA_RATA: el.DATA_RATA,
                IMPORTO_INIZIALE: importo,
                IMPORTO: importoFinale,
                VALIDO: true
            };
        });

        setImporti(iniziali);
    }, [risultatoServerDatiDovutoQuoteIscritto]);

    useEffect(() => {
        switch (sequenzaScaricaDatiIniziali) {
            case 0: ricercaDatiRisorse(); break;
            case 1: ricercaDatiVociDiBilancio(); break;
            case 2: ricercaDatiDovutoQuoteIscritto(); break;
            case 3: ricercaRiferimentiIscritto(); break;
            case 4: if (!props.idIscritto) ricercaDatiIscritti();
                else setSequenzaScaricaDatiIniziali(sequenzaScaricaDatiIniziali+1);
            break;
            case 5: setStatoPagina(STATO_INSERIMENTO_DATI);
        }
    },[sequenzaScaricaDatiIniziali]);

    useEffect(() => {
        if (statoPagina == STATO_RICERCA_DATI_INIZIALI) {
            setStatoPagina(STATO_INSERIMENTO_DATI);
        }
    },[statoPagina]);

    function ricercaDatiRisorse() {
        //ricerco le risorse che mi servono per popolare le tendine:
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoRisorse",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {                
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    setRisultatoServerDatiRisorse(valoreDiRitorno.risultatoRitorno);
                    setSequenzaScaricaDatiIniziali(sequenzaScaricaDatiIniziali+1);
                } else {
                    props.setPagina(props.PAGINE.tornaLogin);
                }
            },
            (error) => {setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function ricercaDatiVociDiBilancio() {
        //ricerco le voci di bilancio che mi servono per popolare le tendine:
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoVociDiBilancio",recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    setRisultatoServerDatiVocidiBilancio(valoreDiRitorno.risultatoRitorno);
                    setSequenzaScaricaDatiIniziali(sequenzaScaricaDatiIniziali+1);
                } else {
                    props.setPagina(props.PAGINE.tornaLogin);
                }
            },
            (error) => {setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function ricercaDatiIscritti() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoPersone",ridotto:1,recordPartenza:1,intervallo:'',emak: props.emak,sessionId:props.sessionId})
        };

        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    setRisultatoServerDatiIscritti(valoreDiRitorno.risultatoRitorno);
                    setSequenzaScaricaDatiIniziali(sequenzaScaricaDatiIniziali+1);
                }
            },
            (error) => {setStatoPagina(STATO_ERRORE_CONNESSIONE);}
        );
    }

    function ricercaDatiDovutoQuoteIscritto() {
        //ricerco il saldo delle quote dovute:
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"debitoQuoteIscritto",id:props.idIscritto,emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica (e.incassiabbass.1)");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    console.log("debitoQuoteIscritto: " + valoreDiRitorno.risultatoRitorno);
                    var componiPersona = valoreDiRitorno.COGNOME+" "+valoreDiRitorno.NOME;
                    if (valoreDiRitorno.NUMERO_TESSERA != "") componiPersona += " ("+valoreDiRitorno.NUMERO_TESSERA+")";
                    setInsIscrittiEdi(componiPersona);
                    setRisultatoServerDatiDovutoQuoteIscritto(valoreDiRitorno.risultatoRitorno);
                    setSequenzaScaricaDatiIniziali(sequenzaScaricaDatiIniziali+1);
                } else {
                    props.setPagina(props.PAGINE.tornaLogin);
                }            
            },
            (error) => {setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }    

    function ricercaRiferimentiIscritto() {
        //ricerco il saldo delle quote versate:
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"elencoRiferimenti",soloReferenti:1,idIscritto:props.idIscritto,emak: props.emak,sessionId:props.sessionId})
        };
    
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
            (valoreDiRitorno) => {
                
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica (e.incassiabbass.3)");
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione===1){
                    setElencoRiferimenti(valoreDiRitorno.risultatoRitorno);
                    if (valoreDiRitorno.risultatoRitorno.length>0) setIndiceRiferimentoSelezionato(0); // seleziona il primo di default
                    setFlagAlertVisivoDestinatarioRicevuta(true);
                    setSequenzaScaricaDatiIniziali(sequenzaScaricaDatiIniziali+1);
                } else {
                    props.setPagina(props.PAGINE.tornaLogin);
                }                    
            },
            (error) => {setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            );
    }

    function inviaNuovoPagamento(presentaRicevuta=0) {
        var dPagamento = controllaDataAAAAMMGG(dataPagamento,2015);
        if (dPagamento === '') {
            alert("Data di Pagamento non valida");
            setDisabilitaBottoni(false);
            return;
        }
        if (dPagamento == "errore") {
            alert("Data di Pagamento non valida");
            setDisabilitaBottoni(false);
            return;
        }
        if(insRisorsaEdi=== ''){
            alert("Risorsa non valida");
            setDisabilitaBottoni(false);
            return;
        }
        if(insVociDiBilancioEdi=== ''){
            alert("Voce di Bilancio non valida");
            setDisabilitaBottoni(false);
            return;
        }

        // nota: idElemento sembra un parametro inutile, da eliminare dopo verifica
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({op:"movPrimaNotaIns",
                idpersona:props.idIscritto,
                risorsa:insRisorsaEdi,                
                permessoInserireRisorsa:permessoInserireRisorsa,
                permessoInserireVoceDiBilancio:permessoInserireVoceDiBilancio,
                vociDiBilancio:insVociDiBilancioEdi,
                note:notePagamento,
                numeroFattura:"",
                dataPagamento:dPagamento,
                idElemento:props.id,
                cognomeRiferimentoSelezionato:indiceRiferimentoSelezionato>=0?elencoRiferimenti[indiceRiferimentoSelezionato].COGNOME:"",
                nomeRiferimentoSelezionato:indiceRiferimentoSelezionato>=0?elencoRiferimenti[indiceRiferimentoSelezionato].NOME:"",
                codiceFiscaleRiferimentoSelezionato:indiceRiferimentoSelezionato>=0?elencoRiferimenti[indiceRiferimentoSelezionato].CODICE_FISCALE:"",
                json_pagamenti: jsonFinale,
                flagIncassoQuoteUnificata: 1,
                generaRicevuta: "quoteUnificata",
                generaFatturaElettronicaAttiva:1,
                emak: props.emak,
                sessionId:props.sessionId
            })
        };
            
        fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valoreDiRitorno) => {
                if(valoreDiRitorno.risultatoOperazione===1){
                    if(presentaRicevuta === 0){
                        if(props.idIscritto) tornaElenco(1,props.idIscritto);
                        else tornaElenco(1);
                    }else{
                        setJsonRicevuta(valoreDiRitorno.jsonRicevuta);
                        setStatoPagina(STATO_VISUALIZZA_RICEVUTA);
                    }
                }
                if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                    setDisabilitaBottoni(false);
                    if(valoreDiRitorno.mess !== undefined) {
                        if(valoreDiRitorno.mess.indexOf("Richiedi permesso per inserire risorse") !== -1){
                            setPermessoInserireRisorsa(-1);
                            setFlagAttivaModaleRichiediPermessoInserire(1);
                            return;
                        } 
                        if(valoreDiRitorno.mess.indexOf("Richiedi permesso per inserire voci di bilancio") !== -1){
                            setPermessoInserireVoceDiBilancio(-1);
                            setFlagAttivaModaleRichiediPermessoInserire(1);
                            return;
                        } 
                        alert (valoreDiRitorno.mess);
                        return;                        
                    }
                }
            },
                (error) => {setStatoPagina(STATO_ERRORE_CONNESSIONE);
            })
    }

    function callbackVisualizzaRicevuta() {
        if(props.idIscritto) tornaElenco(1,props.idIscritto);
        else tornaElenco(1);
    }

    function tornaElenco(eseguitoModifica=0,idIscritto=0) {
        //eseguitoModifica e idIscritto servono per quando arrivi da SchedaIscritto
        props.callbackTermineModifica(eseguitoModifica,idIscritto);
    }

    function callbackSetValoreTendEditabileIscritti(valore,posizione,valoreNonVisibile){
        setInsIscrittiEdi(valore);
        //setInsIdIscrittiEdi(valoreNonVisibile);
        setIndiceRiferimentoSelezionato(-1);
    }

    function callbacksetValoriVoceBilancio(valore,posizione,valoreNonVisibile){
        setInsVociDiBilancioEdi(valore);
        setInsVociDiBilancioAttEdi(valoreNonVisibile);
    }    

    const aggiornaImporto = (valore, indice) => {
        const nuovo = [...importi];
        const valido = regexNumeroValido.test(valore.trim());

        nuovo[indice].IMPORTO = valore;
        nuovo[indice].VALIDO = valido;
        setImporti(nuovo);
    };

    // qui viene definito se un pagamento è da indicare come "parziale"
    // e cioè se l'importo è minore rispetto a quanto è l'importo da pagare (IMPORTO_INIZIALE).
    // In questo modo, se paga tutta la cifra, o se paga di più o se paga l'ultima parte di pagamenti parziali,
    // non viene indicato come pagamento parziale
    const jsonFinale = importi
        .filter(r => r.VALIDO)
        .map(r => ({
        IDASSABB: r.IDASSABB,
        DESCRIZIONE: r.DESCRIZIONE,
        TIPOQUOTA: r.TIPOQUOTA,
        DATA_RATA: r.DATA_RATA,
        PARZIALE: r.IMPORTO_INIZIALE>r.IMPORTO,
        IMPORTO: parseFloat(r.IMPORTO.replace(",", "."))
    }));

    if (statoPagina == STATO_RICERCA_DATI_INIZIALI) {
        return (<Clessidra loading={true}/>)
    }

    if (statoPagina === STATO_VISUALIZZA_RICEVUTA) {
        return (
            <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>
                <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                    <VisualizzaRicevuta {...props} 
                        jsonRicevuta={jsonRicevuta}
                        flagInviaEmail={true}
                        callback={callbackVisualizzaRicevuta}
                    />
                </div>
            </div>
        )
    }

    if (statoPagina == STATO_INSERIMENTO_DATI) {

        const totale = importi.reduce((somma, riga) => {
            const num = parseFloat((riga.IMPORTO || "0").replace(",", "."));
            return somma + (riga.VALIDO && !isNaN(num) ? num : 0);
        }, 0);      

        return (
        <div id="cont" style={{minHeight: "100%",backgroundColor:"#F2F2F2"}}>
            {statoPagina === STATO_INSERIMENTO_DATI &&            
                <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>

                    {flagAttivaModaleRichiediPermessoInserire===1 ?
                        <Modale 
                        titolo="Richiesta permesso inserimento"
                        flagErrore={true}
                        larghezza="lg"
                        contenuto={<div>

                            {permessoInserireRisorsa===-1 ? <>Vuoi davvero inserire {insRisorsaEdi} nell'elenco delle risorse?<br/></> :""}
                            {permessoInserireVoceDiBilancio===-1 ?<>Vuoi davvero inserire {insVociDiBilancioEdi} nell'elenco delle voci di bilancio?<br/><br/>Inizialmente la nuova voce di bilancio verrà impostata come attività principale.<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagAttivaModaleSpiegaAttivita(1)}/><br/> E' possibile modificare l'impostazione recandosi in Gestione Economica, Voci di Bilancio, selezionare la voce desiderata e attuare le modifiche.<br/></> :""}

                        </div>}      
                        bottoni={
                                [{
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setPermessoInserireRisorsa(1); setPermessoInserireVoceDiBilancio(1);}
                                },  
                                {
                                "etichetta":"Annulla",
                                "tipo":"primary",
                                callback:() => {setPermessoInserireRisorsa(0); setPermessoInserireVoceDiBilancio(0);}
                                }] 
                        }
                        />
                    :""}

                    {flagAttivaModaleSpiegaAttivita=== 1 ?
                        <Modale 
                        titolo="Informativa Attività Principali / Secondarie"
                        flagErrore={false}
                        larghezza="lg"
                        contenuto={<div><p>La classificazione di una voce di bilancio come attività principale dipende dalla sua natura.</p> 
                            <p>Per attività principale si intende tutto ciò che è connesso direttamente alle attività sportive ed alle responsabilità istituzionali.
                            L'attivita principale coinvolge i ruoli fondamentali per la pratica sportiva stessa, come istruttori, allenatori, arbitri, tecnici e atleti.
                            Inoltre riguarda tutto ciò che è indispensabile allo svolgimento delle attività sportive: attrezzature, materiali sportivi e strutture adeguate ecc..</p>
                            <p>Sono invece da includere nelle attività secondarie tutto ciò che non è da considerarsi indispensabile per la pratica sportiva diretta.
                            Si tratta spesso di attività legate all’organizzazione e al funzionamento delle strutture sportive.
                            Ad esempio: addetti alla manutenzione degli impianti, addetti alla reception, gestione dell'area ristoro o del merchandising sportivo ecc.. </p>
                            <p>La distinzione tra le attività è utile per adempiere alle norme relative alla Riforma dello Sport.</p>
                            Il <b>report "Attività Principali / Secondarie"</b>, disponibile nella sezione Report, può essere un utile strumento per confrontare il volume di attività 
                            principali e secondarie. 
                            <p>Fornisce inoltre un'analisi dettagliata del rapporto tra attività secondarie e ricavi totali, nonché tra attività secondarie e costi totali.</p>
                        </div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);setFlagAttivaModaleSpiegaAttivita(0)}
                            }    
                        ]}
                        />
                    :""}

                    <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                        <CardTitle>Inserimento Incasso Quote Associative e Abbonamenti</CardTitle>

                        <Row form>  
                            <Col md={12}>
                                <FormGroup>
                                    {props.idIscritto ? <Label>Iscritto: {insIscrittiEdi}</Label> 
                                    : 
                                        <>
                                        <Label>Iscritto*</Label>
                                        <TendinaEditabile
                                            titolo={""}
                                            nomeCampo="COGNOME"
                                            nomeCampo2="NOME"
                                            nomeCampoParentesi="NUMERO_TESSERA"
                                            nomeCampoNonVisibile = "ID"
                                            valoreDefault={insIscrittiEdi}
                                            arrayValori={risultatoServerDatiIscritti}                                            
                                            callbackSetValoreTendEditabile={callbackSetValoreTendEditabileIscritti}
                                        ></TendinaEditabile> 
                                        </>
                                    }                                    
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row form> 
                            <Col md={4}>
                                <FormGroup>
                                    <Label for="dataPagamento">Data Pagamento*</Label>
                                    <Input maxLength={10} type="date" defaultValue={dataOggi}
                                        onChange={(e)=>{ setDataPagamento(e.target.value)}}
                                    />  
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                            <FormGroup>
                            <Label>Risorsa*</Label>   
                            <TendinaEditabile
                                //titolo={"Risorsa*"}
                                nomeCampo="DESCRIZIONE"
                                valoreDefault={insRisorsaEdi}
                                arrayValori={risultatoServerDatiRisorse}                                
                                callbackSetValoreTendEditabile={setInsRisorsaEdi}
                            ></TendinaEditabile>
                            </FormGroup>
                            </Col>
                            <Col md={4}><FormGroup>
                            <label htmlFor="voce">
                                Voce di Bilancio*
                                {insVociDiBilancioAttEdi === '1' 
                                    ?  <> (attività principale<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagAttivaModaleSpiegaAttivita(1)}/>)</>
                                    : insVociDiBilancioAttEdi === '0' 
                                    ? <> (attività secondaria<img src={Interrogativo} className="interrogativo" alt="aiuto" onClick={() => setFlagAttivaModaleSpiegaAttivita(1)}/>)</>
                                    : ''
                                }
                            </label>
                            <TendinaEditabile
                                //titolo={"Voce di Bilancio*"}
                                nomeCampo="DESCRIZIONE"
                                nomeCampoNonVisibile = "TIPO_ATTIVITA"
                                valoreDefault={insVociDiBilancioEdi}
                                arrayValori={risultatoServerDatiVocidiBilancio}                                
                                callbackSetValoreTendEditabile={callbacksetValoriVoceBilancio} 
                            ></TendinaEditabile>
                            </FormGroup>
                            </Col>                                    
                        </Row>
                        
                        {elencoRiferimenti.length > 0 &&
                            <Row form> 
                                <Col md={12}>
                                    <FormGroup>
                                        <Label for="riferimento">Destinatario della ricevuta*</Label>
                                        <br/>
                                        <select 
                                            className="inputStandard" 
                                            style={{backgroundColor:flagAlertVisivoDestinatarioRicevuta?"#FF0000":"", color:flagAlertVisivoDestinatarioRicevuta?"#FFFFFF":""}} 
                                            value={indiceRiferimentoSelezionato} 
                                            onChange={(e) => {setIndiceRiferimentoSelezionato(e.target.value);setFlagAlertVisivoDestinatarioRicevuta(false)}}
                                        >
                                            <option value={-1}>L'iscritto stesso</option>
                                            {elencoRiferimenti.map((elemento, indice) => <option key={indice} value={indice}>{elemento.COGNOME+" "+elemento.NOME}</option>)}                                                    
                                        </select>                                                

                                    </FormGroup>
                                </Col>
                            </Row>
                        }                        

                        <div style={{ margin: "auto" }}>
                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                <thead>
                                <tr>
                                    <th style={{ textAlign: "left", padding: "8px", whiteSpace: "nowrap" }}>Scad. Pag.</th>
                                    <th style={{ textAlign: "left", padding: "8px", whiteSpace: "nowrap" }}>Descrizione</th>
                                    <th style={{ textAlign: "right", padding: "8px", whiteSpace: "nowrap" }}>Dovuto (€)</th>
                                    <th style={{ textAlign: "right", padding: "8px", whiteSpace: "nowrap" }}>Pagato (€)</th>
                                    <th style={{ textAlign: "center", padding: "8px", whiteSpace: "nowrap" }}>Pagato<br/>tutto/niente</th>
                                </tr>
                                </thead>
                                <tbody>
                                {risultatoServerDatiDovutoQuoteIscritto.map((elemento, indice) => (
                                    <tr key={indice}>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                        <TrasformaDateAUmano data={elemento.DATA_RATA}/>
                                    </td>
                                    <td style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                        {elemento.DESCRIZIONE}
                                    </td>
                                    <td style={{ padding: "8px", textAlign: "right", borderBottom: "1px solid #ccc" }}>
                                        {/* prima che scatti la useEffect che setta importi, importi[indice] è undefined. La useEffect è praticamente immediata
                                        quindi l'umano non vede l'attesa, ma il programma arriva qua anche troppo presto, con undefined, quindi serve questo controllo */}
                                        {importi!=undefined ? importi[indice]!=undefined ? importi[indice].IMPORTO_INIZIALE : "...":"..."}
                                    </td>
                                    <td style={{ padding: "8px", textAlign: "right", borderBottom: "1px solid #ccc" }}>
                                        <input
                                        type="text"
                                        inputMode="decimal"
                                        value={importi[indice]?.IMPORTO ?? ""}
                                        onChange={(e) => aggiornaImporto(e.target.value, indice)}
                                        style={{
                                            width: "80px",
                                            textAlign: "right",
                                            border: `1px solid ${importi[indice]?.VALIDO ? "#ccc" : "red"}`,
                                            borderRadius: "4px",
                                            padding: "4px",
                                            backgroundColor: importi[indice]?.VALIDO ? "white" : "#ffe6e6"
                                        }}
                                        />
                                    </td>
                                    <td style={{ padding: "8px", textAlign: "center", borderBottom: "1px solid #ccc" }}>
                                        <img src={Cerchio_ok} height="20" width="20" alt="pagata" onClick={() => aggiornaImporto(importi[indice].IMPORTO_INIZIALE, indice)}/>
                                        <img src={Cerchio_no} height="20" width="20" alt="non pagata" style={{marginLeft:5}} onClick={() => aggiornaImporto("0", indice)}/>
                                    </td>
                                    </tr>
                                ))}
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td style={{ padding: "8px", fontWeight: "bold" }}></td>
                                    <td style={{ padding: "8px", fontWeight: "bold" }}>Totale pagato</td>
                                    <td style={{ padding: "8px", fontWeight: "bold" }}></td>
                                    <td style={{ padding: "8px", textAlign: "right", fontWeight: "bold" }}>
                                    {totale.toFixed(2).replace(".", ",")} €
                                    </td>
                                </tr>
                                </tfoot>
                            </table>                            
                        </div>

                        <Row form> 
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="note">Note Pagamento</Label>                                          
                                        <textarea
                                            id="note"
                                            name="note"
                                            value={notePagamento}
                                            onChange={(e) => setNotePagamento(e.target.value)}
                                            rows={10}
                                            maxLength={10000}
                                            style={{ width: "100%" }}
                                        />  
                                </FormGroup>
                            </Col>
                        </Row>

                        {props.identitaSelezionata.fatturazione_elettronica==1 ?
                            <div style={{marginTop:10}}>Ricevuta e fattura elettronica verranno generate automaticamente.</div>
                        :
                            <div style={{marginTop:10}}>La ricevuta verrà generata automaticamente.<br/>Fatturazione elettronica non attiva. Contatta assistenza@gestionesportiva.it per attivarla.</div>
                        }


                    </div>
                    <div className="schedaSpazioInferiore">

                        {haPersonalizzazione(props.identitaSelezionata, "invia_ricevuta_email") ?
                            <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);inviaNuovoPagamento(1)}}>Inserisci e invia mail ricevuta</Button>
                        :
                        <>
                            <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);inviaNuovoPagamento(0)}}>Inserisci</Button>
                            <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);inviaNuovoPagamento(1)}}>Inserisci e vedi ricevuta</Button>
                        </>
                        }

                        <Button disabled={disabilitaBottoni} color="primary" className="mt-2 bottoneMargineADestra" onClick={() => tornaElenco()} >
                        {props.idIscritto ? 
                            props.labelRitorno && props.labelRitorno !== "" ?
                                <>{props.labelRitorno}</> 
                            :
                                <>Annulla inserimento incasso</> 
                        :
                            <>Torna all'elenco</>
                        }
                        </Button>

                    </div>
                </div>
            }
        </div>
        )
    }

    if (statoPagina== STATO_ERRORE_CONNESSIONE) {
        return (<div>Errore Scheda Incassi: errore connessione</div>);
    }

    return (<div>Errore Scheda Incassi: pagina non trovata</div>);
}
export default SchedaIncassiAbbAssUnificata;